import React, { useEffect, useState } from 'react';

import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import TabsHeader from '@shared/components/TabsHeader';
import { FormSearchAssist } from '@shared/pages/AssistCard/FormSearchAssist';
import { SearchResultsAssist } from '@shared/pages/AssistCard/SearchResultsAssist';
import { Grid, Typography } from '@mui/material';

import SearchSkeleton from '@shared/pages/AssistCard/SearchResultsAssist/SearchSkeleton';
import LoadingImage from '@shared/components/LoadingImage';

import AssistTimedModal from './AssistTimedModal';

export default () => {
  const history = useHistory();
  const searchInfo = useSelector(store => store.searchAssistReducer);
  const [isLoadingResults, setIsLoadingResults] = useState(true);
  const [searchResults, setSearchResults] = useState([]);
  const [xTransactionId, setXtransactioId] = useState('');

  useEffect(() => {
    if (!searchInfo.checkIn && !searchInfo.checkOut)
      history.push('/assist-card');
  }, []);

  const onReloadSearch = () => {
    window.location.reload();
  };

  return (
    <>
      <TabsHeader site={3} />
      <FormSearchAssist
        navigatesToSearch={false}
        setIsLoadingResults={setIsLoadingResults}
        setSearchResults={setSearchResults}
        setXtransactioId={setXtransactioId}
      />
      {isLoadingResults ? (
        <>
          <SearchSkeleton />
          <LoadingImage site={'AssistCard'} isOpen={isLoadingResults} />
        </>
      ) : searchResults.length > 0 ? (
        <SearchResultsAssist
          searchResults={searchResults}
          setIsLoadingResults={value => setIsLoadingResults(value)}
          isLoadingResults={isLoadingResults}
          xTransactionId={xTransactionId}
        />
      ) : (
        <Grid
          container
          style={{
            height: '40vh',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Typography>No se encontraron resultados</Typography>
        </Grid>
      )}
      <AssistTimedModal
        onReloadSearch={onReloadSearch}
        searchResults={searchResults}
      />
    </>
  );
};
